export default __webpack_public_path__ + "static/media/ReactIcon.5166d1ab.png";